/**
 * Shared site data for Amigo Inn & RV Park.
 * Reused by header, footer and every future internal page.
 */

export const BUSINESS = {
  name: "Amigo Inn & RV Park",
  street: "209 Lake Shore Dr",
  city: "Zapata",
  region: "TX",
  postalCode: "78076",
  country: "US",
  phone: "956-765-3095",
  phoneHref: "tel:+19567653095",
  email: "amigoinn13@gmail.com",
  officeHours: "8:00 AM–5:00 PM",
  siteUrl: "https://amigoinn-rvpark.com/",
} as const;

export const ADDRESS_ONE_LINE = `${BUSINESS.street}, ${BUSINESS.city}, ${BUSINESS.region} ${BUSINESS.postalCode}`;

/** Google Maps search for the Zapata property (never the old Cotulla link). */
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  `${BUSINESS.name}, ${ADDRESS_ONE_LINE}`,
)}`;

export const BOOKING_URL = "https://amigo.bookmysites.com/reservations/checkout-availability";

/** TODO: verify before production deployment. */
export const TOUR_360_URL =
  "https://app.tillerxr.com/tour-viewer/7f6ae646-3c54-4dd2-a8d7-34f358a6ebd6?image=68823a3a-7f1a-4ed9-9b0f-c0aa2ba6eada";

/** TODO: verify before production deployment. */
export const FACEBOOK_URL = "https://www.facebook.com/amigo.guideservice";

export const DESIGNER_URL = "https://southeastpublications.com/";

/** Exact legacy WordPress paths — trailing slashes are required. */
export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about-us/" },
  { label: "Rooms and Parks", href: "/rooms-and-parks/" },
  { label: "Activities", href: "/activities/" },
  { label: "Contact Us", href: "/contact-us/" },
] as const;

export const ABOUT_PATH = "/about-us/";
export const ROOMS_PATH = "/rooms-and-parks/";
export const ACTIVITIES_PATH = "/activities/";
export const CONTACT_PATH = "/contact-us/";
export const FISHING_GUIDE_PATH = "/activities/falcon-lake-fishing-guide/";
export const WINTER_TEXANS_GUIDE_PATH = "/activities/winter-texans-guide/";

/** Shared JSON-LD entity id for the Campground on every page that references it. */
export const CAMPGROUND_ID = `${BUSINESS.siteUrl}#campground`;

/**
 * Cast helper for TanStack `<Link to={…}>` while remaining WordPress paths
 * are still being migrated into the React app. Runtime navigation uses the
 * real string; this only satisfies the generated route union.
 */
export function routeTo(
  path: string,
):
  | "/"
  | "/about-us/"
  | "/rooms-and-parks/"
  | "/activities/"
  | "/contact-us/"
  | "/activities/falcon-lake-fishing-guide/"
  | "/activities/winter-texans-guide/" {
  return path as
    | "/"
    | "/about-us/"
    | "/rooms-and-parks/"
    | "/activities/"
    | "/contact-us/"
    | "/activities/falcon-lake-fishing-guide/"
    | "/activities/winter-texans-guide/";
}


/** YYYY-MM-DD in local time (no timezone shift from toISOString). */
export function formatISODate(date: Date): string {
  const y = date.getFullYear();
  const m = `${date.getMonth() + 1}`.padStart(2, "0");
  const d = `${date.getDate()}`.padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Booking URL with optional dates; falls back to the clean URL. */
export function buildBookingUrl(checkin?: string, checkout?: string): string {
  if (!checkin || !checkout) return BOOKING_URL;
  const params = new URLSearchParams({
    checkin_date: checkin,
    checkout_date: checkout,
  });
  return `${BOOKING_URL}?${params.toString()}`;
}
